<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch04">
<div class="chapterHead">
<h2 class="chapterTitle3"><span class="xrefInternal"><a href="#/contents#ch_04"><span class="bold">J<span class="smallCaps">OAN</span> B<span class="smallCaps">AEZ</span></span></a></span><span class="footnoteRef"><span href="#/footnote#footnote4" id="fn4" title="Link target outside of Sample"><sup>*</sup></span></span></h2></div>
<div class="chapterBody">
<p class="image1"><img alt="image" src="20.jpg"/></p>
<p class="image1"><img alt="image" src="21.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch04.vue?28680576